export const MINT_OPENED = false;